<div class="notify-template-thumbnail">
    <div class="cover-image">
        <img src="{{ template.CoverBannerS3Url | decode | sanitize }}" alt="Cover Image" *ngIf="template.CoverBannerS3Url">
    </div>
    <div class="tag-line">{{'notifyTemplates.thumbnailTagLine'|translate}}</div>
    <h6 class="title">{{'notifyTemplates.thumbnailTitle'|translate}}</h6>
    <div class="banner-wrapper">
        <div class="banner-image" *ngIf="template?.BannerS3Url">150 x 150</div>
        <div class="banner-description paragraph-placeholder">
            <span class="sentence-placeholder large"></span>
            <span class="sentence-placeholder medium"></span>
            <span class="sentence-placeholder medium"></span>
            <span class="sentence-placeholder medium"></span>
            <span class="sentence-placeholder medium"></span>
        </div>
    </div>
    <div class="divider"></div>
    <div class="content-wrapper">
        <div class="content-item paragraph-placeholder">
            <span class="sentence-placeholder medium"></span>
            <span class="sentence-placeholder large"></span>
        </div>
        <div class="content-item paragraph-placeholder">
            <span class="sentence-placeholder full"></span>
            <span class="sentence-placeholder full"></span>
            <span class="button-placeholder"></span>
        </div>
    </div>

    <div class="showcase" *ngIf="showcaseItems.length">
        <div class="divider"></div>

        <h6 class="title">{{'notifyTemplates.shipperShowcase'|translate}}</h6>
        <div class="showcase-items">
            <div class="showcase-item" *ngFor="let item of showcaseItems"></div>
        </div>
        <span class="button-placeholder"></span>
    </div>
</div>
